import { KeyValueModel } from "model/api";

export const ModBcIcmsMock: KeyValueModel[] = [
    // new KeyValueModel(0, "Margem Valor Agregado(%)"),
    // new KeyValueModel(1, "Pauta (Valor)"),
    // new KeyValueModel(2, "Preço Tabelado Máx. (Valor)"),
    new KeyValueModel(3, "Valor da Operação"),
];
